import { Component } from 'react';

/**
 * Isolates cashier active-panel crashes so the whole account route
 * does not fall into RouteErrorBoundary ("Sayfa yüklenemedi").
 */
export default class CashierSoftBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const message = String(error?.message || error || 'unknown').slice(0, 400);
    const stack = String(error?.stack || '').slice(0, 800);
    const comp = String(info?.componentStack || '').slice(0, 800);
    try {
      sessionStorage.setItem('vb_cashier_err', message);
      sessionStorage.setItem('vb_cashier_err_stack', `${stack}\n${comp}`.slice(0, 1200));
      sessionStorage.setItem('vb_route_err', `cashier:${message}`.slice(0, 300));
    } catch {}
    if (typeof this.props.onError === 'function') {
      try { this.props.onError(error, info); } catch {}
    }
  }

  render() {
    if (this.state.error) {
      const tr = typeof this.props.tr === 'function' ? this.props.tr : (k) => k;
      const detail = String(this.state.error?.message || this.state.error || '').slice(0, 180);
      return (
        <div className={this.props.className || 'payments-form-panel__notice'} role="alert">
          <p>{tr('account.payments.activePanelError') || 'Ödeme paneli yüklenemedi. Lütfen tekrar deneyin.'}</p>
          {detail ? (
            <p style={{ opacity: 0.7, fontSize: 12, wordBreak: 'break-word' }}>{detail}</p>
          ) : null}
          <button
            type="button"
            className={this.props.buttonClassName || 'payments-form__quick-btn'}
            onClick={() => {
              this.setState({ error: null });
              if (typeof this.props.onRetry === 'function') this.props.onRetry();
            }}
          >
            {tr('account.payments.havale.tryAgain') || 'Tekrar dene'}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
